import type { FaireProductEntity } from "../../entity_types/product";

export const p_3wks9bxrk6: FaireProductEntity = {
  token: "p_3wks9bxrk6",
  type: "product",
  name: "Deluxe Assortment Gift Box 4 oz",
  brandToken: "b_3djswmgi7l",
  brandName: "Coblentz Chocolate Company",
  imageUrl:
    "https://cdn.faire.com/fastly/d000134ab78e2ee0811eff1643f61f6843529a157678190610f9b3a046204221.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5aec0d5f99389d042e1424d2cbb739c1f45a1a6ec8b84e6f71b1a1785da86c9d.jpeg",
    "https://cdn.faire.com/fastly/33dcefdeb36dbff1cb16e1291b3369e32a50cf6764a08e7fda49d0676d03d42f.jpeg",
    "https://cdn.faire.com/fastly/738fc88c2744a7d318faf62d738649eb37b1b130b76bc13a0cc970d17d172cef.png",
  ],
  priceDollars: 5.25,
  description:
    "Top selling assortment of milk and dark items in a 4 oz, 8 piece classic gift box",
  tags: [],
  msrpDollars: 10.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T08:28:40.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
